module.exports = __webpack_public_path__ + "img/mistletoe.d6df2181.svg";